import React from "react"
import "./App.css"
import { useContext } from "react"
import { MarkLogicContext, SearchBox, ResultsSnippet } from "ml-fasttrack"

function App() {
  const context = useContext(MarkLogicContext)
  return (
    <div>
      <SearchBox onSearch={(params) => context.setQtext(params.q)} />
      <ResultsSnippet results={context.searchResponse.results} />
    </div>
  )
}

export default App
